import axiosLib, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { UserRoutes } from "User/routes";

const devApiPath = import.meta.env.VITE_API_PATH ?? "";

export const appAxios = axiosLib.create({
  baseURL: devApiPath + "/api/",
  timeout: 10000,
});

export const requestInterceptor = function (
  config: InternalAxiosRequestConfig,
) {
  const token = localStorage.getItem("token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";

  return config;
};

appAxios.interceptors.request.use(requestInterceptor);

export const responseSuccessfullInterceptor = function (
  response: AxiosResponse,
) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
};

export const responseErrorInterceptor = function (
  error: AxiosError | Error | string,
) {
  if (
    error instanceof AxiosError &&
    error.status === 401 &&
    !error.request.responseURL.endsWith("login_check")
  ) {
    localStorage.removeItem("token");
    window.location.href = UserRoutes.USER_LOGIN;
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
};

appAxios.interceptors.response.use(
  responseSuccessfullInterceptor,
  responseErrorInterceptor,
);
